<template>
    <div v-show="showValidationMessages" class="custom-tooltip">
        <AgGridCellValidationMessage
            v-for="(validation, idx) in failedValidations" :key="idx"
            :validation="validation"/>
    </div>
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'
import {FieldEditorTypes} from '../../../../../../../types/document-viewer/field/modules/editor'
import {getFieldValidationPriority} from '../../../../../../../types/document-viewer/field/modules/validation'
import AgGridCellValidationMessage from './AgGridCellValidationMessage'

export default Vue.extend({
    name: 'AgGridCellTooltip',
    components: {
        AgGridCellValidationMessage
    },
    computed: {
        ...mapGetters('doc_viewer_metadata', [
            'getFieldMetadata',
            'isTouchedForm'
        ]),

        field() { // FormField
            return this.params.settings || {}
        },

        lineIdx() {
            return this.params.data ? this.params.data.lineIdx : -1
        },

        isNumericField() {
            return this.editor.type === FieldEditorTypes.NUMERIC
        },

        metadata() {
            return this.getFieldMetadata({path: this.field.path, idx: this.lineIdx}) || {}
        },

        showValidationMessages() {
            return (this.isTouchedForm || this.metadata.touched) && this.failedValidations.length !== 0
        },

        failedValidations() {
            return _.isArray(this.metadata.validations) ? this.metadata.validations
                .filter(v => !v.valid)
                .sort((a, b) => getFieldValidationPriority(b.level) - getFieldValidationPriority(a.level)) : []
        }
    }
})
</script>

<style scoped>
    .custom-tooltip {
        position: absolute;
        width: auto;
        height: auto;
        padding: 16px;
        border: 1px solid #cccccc;
        border-radius: 3px;
        overflow: hidden;
        pointer-events: none;
        transition: opacity 1s;
        background-color: #232323;
        color: white;
        font-size: 14px;
        font-weight: 500;
        max-width: 600px;
    }

    .custom-tooltip.ag-tooltip-hiding {
        opacity: 0;
    }
</style>
